import { alpha } from '@mui/material';

export const getModalStyles = (theme, isMobile) => ({
    paper: {
        borderRadius: 2,
        minWidth: isMobile ? '90vw' : '320px'
    },
    container: {
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center'
    },
    iconWrapper: {
        width: 48,
        height: 48,
        borderRadius: '50%',
        bgcolor: alpha(theme.palette.error.main, 0.1),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        mb: 2,
        color: theme.palette.error.main
    },
    title: {
        fontWeight: 600,
        mb: 1
    },
    subtitle: {
        mb: 3
    },
    actionsContainer: {
        display: 'flex',
        gap: 1.5,
        width: '100%'
    },
    cancelButton: {
        color: theme.palette.text.secondary
    }
});
